import playInMediaType$ from './playInMediaType'
import forceLocalMute$ from './forceLocalMute'

export default {
  forceLocalMute$,
  playInMediaType$
}
